import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import ProjectListContent from '../components/ProjectListContent'; 
import axios from 'axios';
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import withRouter from '../components/withRouter';
import PageHeader from '../components/PageHeader'; 
import {api_base_url} from '../common/Constants'; 
 
class ProjectList extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading:1,
            type:[]
        }
    }

    componentDidMount()
    {
        
    }
 
    render()
    {
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <PageHeader title="Ongoing Projects" banner="Projects"/>
                <ProjectListContent   />  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(ProjectList);